




































































import { Component } from 'vue-property-decorator';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { paymentService } from '@/shared';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  components: {
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
  },
})
 class DealPaymentPage extends Base {

  public paymentDialog: boolean = false;
  public transactionHeaderId: string = '';
  public detailId: string = '';
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public storeDeal: any = {};

  public cenposDialog: boolean = false;
  public squareDialog: boolean = false;
  public isCloverDialog: boolean = false;

  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public storeName: string = '';
  public provider: string = '';
  public dealNumber: string = '';
  public storeId: number = 0;
  public amountToBePaid: string = '';
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public isCloverConfigured: boolean = false;
  public stockNumberForPayment: string = '';
  public email: string = '';
  public zipCode: string = '';
  public city: string = '';
  public state: string = '';
  public address: string = '';
  public customerCode: string = '';

  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public isOverrideCCFeeApplied: boolean = true;
  public byPassReason: string = '';
  public firstName: string = '';
  public lastName: string = '';

  public mounted(): void {

    this.$watch("dealNumber", (newVal) => {
      this.paymentOptions.recordKey = newVal;
    });

    this.$watch("customerCode", (newVal) => {
      this.paymentOptions.customerKey = newVal;
    });

    this.$watch("amountToBePaid", (newVal) => {
      this.paymentOptions.amount = Number(newVal);
    });

    this.$watch("address", (newVal) => {
      this.paymentOptions.address = newVal;
    });

    this.$watch("city", (newVal) => {
      this.paymentOptions.city = newVal;
    });

    this.$watch("state", (newVal) => {
      this.paymentOptions.state = newVal;
    });

    this.$watch("zipCode", (newVal) => {
      this.paymentOptions.zipcode = newVal;
    });

    this.$watch("transactionHeaderId", (newVal) => {
      this.paymentOptions.transactionHeaderId = newVal;
    });

    this.$watch("detailId", (newVal) => {
      this.paymentOptions.lastPaymentDetailId = newVal;
    });

    this.$watch("stockNumberForPayment", (newVal) => {
      this.paymentOptions.other = newVal;
    });

    this.$watch("email", (newVal) => {
      this.paymentOptions.customerEmail = newVal;
    });

    this.$watch("storeDeal.amountWithServiceCharge", (newVal) => {
      this.paymentOptions.amountWithServiceCharges = newVal;
    });

    this.$watch("byPassReason", (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });

    this.$watch("isOverrideCCFeeApplied", (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });

    this.$watch("storeId", (newVal) => {
      this.paymentOptions.storeId = newVal;
    });

    this.$watch("firstName", (newVal) => {
      this.paymentOptions.firstName = newVal;
    });
    this.$watch("lastName", (newVal) => {
      this.paymentOptions.lastName = newVal;
    });
    this.transactionHeaderId = this.$route.params.txid;
    this.detailId = this.$route.params.detailid;
    if (this.transactionHeaderId && this.detailId) {
      this.getDeal(this.transactionHeaderId, this.detailId);
    } else {
      this.showAlert(false, this.$t('dealPayment.alertTransactionIdEmpty'));
    }
    this.currentUrl = window.location.href;


  }

  public updateCenposDialog(cenposDialogValue) {
    this.cenposDialog = cenposDialogValue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public updateZipCode(zipCodeValue) {
    this.zipCode = zipCodeValue;
  }

  public async getDeal(
    transactionHeaderId: string,
    txDetailId: string
  ): Promise<void> {
    try {
      this.loading = true;
      const dealDetail = await paymentService.getDealDetail(
        transactionHeaderId,
        txDetailId
      );
      this.isOverrideCCFeeApplied = dealDetail.isOverrideCCFeeApplied;
      this.byPassReason = dealDetail.byPassReason;
      this.storeDeal = dealDetail;
      this.provider = dealDetail.provider;
      this.storeName = dealDetail.storeName;
      this.dealNumber = dealDetail.dealNumber;
      this.storeId = dealDetail.storeId;
      this.stockNumberForPayment = dealDetail.stockNumber;
      this.isCenposConfigured = dealDetail.isCenposConfigured;
      this.isSquareConfigured = dealDetail.isSqaureConfigured;
      this.isCloverConfigured = dealDetail.isCloverConfigured;
      this.amountToBePaid = dealDetail.amount;
      this.email = dealDetail.email;
      this.zipCode = dealDetail.zipCode;
      this.city = dealDetail.city;
      this.state = dealDetail.state;
      this.address = dealDetail.address;
      this.customerCode = dealDetail.customerKey;
      this.firstName = dealDetail.firstName;
      this.lastName = dealDetail.lastName;
      this.storeName = dealDetail.storeName;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
      this.tenantId = this.userSession.tenantId;
      this.enterpriseId = this.userSession.enterpriseId;

      if (this.storeDeal.status === 'Approved') {
        this.showAlert(true, this.$t('dealPayment.alertPaymentApproved'));
      } else if (this.storeDeal.paymentDetailStatus === 'InProcess') {
        this.showAlert(true, this.$t('Payment is in process, Please check the final status in Payment report.'));
      }
    } finally {
      this.loading = false;
    }
  }

  public async pay(): Promise<void> {
    try {
      if (this.provider == 'Vantiv') {
        this.requestProgress = true;
        const payment = await paymentService.pay(
          this.transactionHeaderId,
          this.detailId
        );
        window.location.href = payment.paymentUrl;
      } else if (this.provider == 'Cenpos') {
        if (this.isCenposConfigured) {
          const validateMessage = this.validateCenpos();
          if (validateMessage == '') {
            this.paymentDialog = true;
            this.$root.$emit('validatePaymentProvider');
          } else {
            const message =
              'Can not Make the payment because, Customer' +
              validateMessage +
              ' are Empty.';
            this.showAlert(false, message);
          }
        } else {
          this.showAlert(false, this.$t('stores.cenpos.alertCeponsConfig'));
        }
      }
      else {
        this.paymentDialog = true;
        this.$root.$emit('validatePaymentProvider');
      }
    } finally {
      this.requestProgress = false;
    }
  }

  public validateCenpos(): string {
    let message = '';
    if (this.city == undefined || this.city == '') {
      message += ' City';
    }
    if (this.customerCode == undefined || this.customerCode == '') {
      message += ' CustomerKey';
    }

    if (this.state == undefined || this.state == '') {
      message += ' State';
    }
    if (this.address == undefined && this.address == '') {
      message += ' Address';
    }

    return message;
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }
  public paymentOptions: IPaymentDialog = {
    id: "DealPaymentAnonymous",
    url: window.location.href,
    recordKey: this.dealNumber,
    customerKey: this.customerCode,
    amount: Number(this.amountToBePaid),
    address: this.address,
    city: this.city,
    state: this.state,
    zipcode: this.zipCode,
    type: "0",
    transactionHeaderId: this.transactionHeaderId,
    lastPaymentDetailId: this.detailId,
    other: this.stockNumberForPayment,
    recordIdentifier: "Deal",
    customerEmail: this.email,
    amountWithServiceCharges: this.storeDeal.amountWithServiceCharge,
    showTextField: true,
    bypassReason: this.byPassReason,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    storeId: this.storeId,
    firstName: this.firstName,
    lastName: this.lastName
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
export default DealPaymentPage;
